import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function parsePhoneParts({ countryCode, phoneNumber, phone } = {}) {
  const code = countryCode != null ? String(countryCode).trim() : '';
  const number = phoneNumber != null ? String(phoneNumber).trim() : '';
  if (code || number) {
    return { countryCode: code, phoneNumber: number };
  }
  if (!phone || phone === '—') return { countryCode: '', phoneNumber: '' };
  const trimmed = String(phone).trim();
  if (trimmed === '—') return { countryCode: '', phoneNumber: '' };

  const parsedFromString = tryParseE164(trimmed);
  if (parsedFromString) {
    return {
      countryCode: `+${parsedFromString.countryCallingCode}`,
      phoneNumber: parsedFromString.nationalNumber,
    };
  }

  const spaceIdx = trimmed.indexOf(' ');
  if (spaceIdx > 0) {
    return {
      countryCode: trimmed.slice(0, spaceIdx),
      phoneNumber: trimmed.slice(spaceIdx + 1).trim(),
    };
  }

  const digitsOnly = trimmed.replace(/\D/g, '');
  if (digitsOnly) {
    const parsed = tryParseE164(`+${digitsOnly}`);
    if (parsed) {
      return {
        countryCode: `+${parsed.countryCallingCode}`,
        phoneNumber: parsed.nationalNumber,
      };
    }
  }

  return { countryCode: '', phoneNumber: trimmed };
}

function tryParseE164(value) {
  if (!value) return null;
  const normalized = String(value).trim().startsWith('+') ? String(value).trim() : `+${String(value).replace(/\D/g, '')}`;
  if (normalized === '+') return null;
  try {
    const parsed = parsePhoneNumberFromString(normalized);
    return parsed || null;
  } catch {
    return null;
  }
}

function formatUsFallback(numDigits) {
  if (numDigits.length !== 10) return numDigits;
  return `(${numDigits.slice(0, 3)}) ${numDigits.slice(3, 6)}-${numDigits.slice(6)}`;
}

/**
 * Format for read-only display — matches PhoneInput style, e.g. +1 (312) 131-3131
 */
export function formatPhoneForDisplay({ countryCode, phoneNumber, phone } = {}) {
  const parts = parsePhoneParts({ countryCode, phoneNumber, phone });
  const dialDigits = (parts.countryCode || '').replace(/\D/g, '');
  const numDigits = (parts.phoneNumber || '').replace(/\D/g, '');

  if (!dialDigits && !numDigits) {
    return { countryCode: '', national: '', full: '' };
  }

  const parsed = tryParseE164(`+${dialDigits}${numDigits}`);

  if (parsed) {
    const cc = `+${parsed.countryCallingCode}`;
    const national = parsed.formatNational().replace(/^0+/, '').trim();
    return { countryCode: cc, national, full: `${cc} ${national}` };
  }

  if (dialDigits === '1' && numDigits.length === 10) {
    const national = formatUsFallback(numDigits);
    return { countryCode: '+1', national, full: `+1 ${national}` };
  }

  const cc = dialDigits ? `+${dialDigits}` : '';
  return {
    countryCode: cc,
    national: numDigits,
    full: [cc, numDigits].filter(Boolean).join(' '),
  };
}
